import './header-menu-core.js';

/*
 * BGShopping desktop mega-menu hover guard.
 * Keep the native Shopify menu logic, but do not let a desktop submenu
 * disappear while the pointer is travelling from the top-level item into it.
 * Touch/mobile and keyboard focus keep Shopify's native behaviour.
 */
const HeaderMenu = customElements.get('header-menu');

if (HeaderMenu && !HeaderMenu.prototype.__bgshoppingHoverGuard) {
  const nativeDeactivate = HeaderMenu.prototype.deactivate;
  const closeTimers = new WeakMap();
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const clearCloseTimer = (menu) => {
    const timer = closeTimers.get(menu);
    if (timer) clearTimeout(timer);
    closeTimers.delete(menu);
  };

  const pointerStillInsideMenu = (menu) => {
    if (!menu || !menu.isConnected) return false;

    if (menu.matches(':hover')) return true;
    if (menu.querySelector('.menu-list__list-item:hover, .menu-list__submenu:hover')) return true;

    const overflow = menu.refs?.overflowMenu?.shadowRoot?.querySelector('[part="overflow"]');
    if (overflow?.matches(':hover')) return true;

    return false;
  };

  const scheduleClose = (menu, event, firstDelay = 650) => {
    clearCloseTimer(menu);

    const check = () => {
      if (pointerStillInsideMenu(menu)) {
        closeTimers.set(menu, setTimeout(check, 160));
        return;
      }

      closeTimers.delete(menu);
      nativeDeactivate.call(menu, event);
    };

    closeTimers.set(menu, setTimeout(check, firstDelay));
  };

  HeaderMenu.prototype.deactivate = function bgshoppingDeactivate(event) {
    const isDesktopPointerLeave =
      finePointer.matches &&
      event &&
      event.type === 'pointerleave' &&
      event.target instanceof Element;

    if (!isDesktopPointerLeave) {
      clearCloseTimer(this);
      return nativeDeactivate.call(this, event);
    }

    scheduleClose(this, event);
  };

  document.addEventListener(
    'pointerenter',
    (event) => {
      if (!finePointer.matches || !(event.target instanceof Element)) return;
      const menu = event.target.closest('header-menu');
      if (menu) clearCloseTimer(menu);
    },
    true
  );

  HeaderMenu.prototype.__bgshoppingHoverGuard = true;
}
